export const css = {
	root: 'XYR3ysXg',
	content: 'KUTbfNrK',
	title: 'Jq7Pf16-',
	demote: 'IPzsiag2',
	' _key': 'card/motivation'
};

export default css;
